/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class SystemManagerInfo {
    importButton! : string;
    columnsName! : string[];
    addButton! : string;
    exportButton! : string;
    cancelRequestButton! : string;
}